import { render, staticRenderFns } from "./ShareSection.vue?vue&type=template&id=bef5311e&scoped=true"
import script from "./ShareSection.vue?vue&type=script&lang=js"
export * from "./ShareSection.vue?vue&type=script&lang=js"
import style0 from "./ShareSection.vue?vue&type=style&index=0&id=bef5311e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef5311e",
  null
  
)

export default component.exports